export default "__VITE_ASSET__CbtvoJ$5__"